import './offer.scss';

import Swiper from 'swiper';
import { A11y, Navigation, Pagination, Keyboard } from 'swiper/modules';
import 'swiper/scss/a11y';
import 'swiper/scss/keyboard';

require('../../assets/images/kombi-tips-stoerer.svg');

class Offer {
    constructor ($element) {
        this.$offer = $element;
        this.$$offerSubmits = this.$offer.querySelectorAll('[data-lot-offer="submit"]');
        this.$offerSlider = this.$offer.querySelector('[data-lot-offer-slider="slider"]');
        this.$sliderPagination = this.$offer.querySelector('[data-lot-offer-slider="pagination"]');
        this.$prevButton = this.$offer.querySelector('[data-slider-prev]');
        this.$nextButton = this.$offer.querySelector('[data-slider-next]');

        this.slider = null;
    }

    init () {
        this.initSlider();

        if (this.$$offerSubmits.length > 0) {
            this.$$offerSubmits.forEach($offerSubmit => {
                const $submitStatus = $offerSubmit.querySelector('[data-status="visible"]');
                $offerSubmit.onclick = () => {
                    $offerSubmit.setAttribute('aria-pressed', 'true');
                    $submitStatus.setAttribute('aria-hidden', 'false');
                    $offerSubmit.classList.add('disabled');
                };
            });
        }
    }

    initSlider () {
        this.slider = new Swiper(this.$offerSlider, {
            modules: [A11y, Navigation, Pagination, Keyboard],
            initialSlide: 1,
            slidesPerView: 1,
            spaceBetween: 22,
            resistanceRatio: 0,
            slideToClickedSlide: false,
            threshold: 12,
            speed: 500,
            autoHeight: true,
            breakpointsInverse: true,
            observer: true,
            pagination: {
                el: this.$sliderPagination,
                clickable: false
            },
            a11y: {
                prevSlideMessage: window.translations.prev_slide_message,
                nextSlideMessage: window.translations.next_slide_message,
                paginationBulletMessage: `${window.translations.pagination_bullet_message} {{index}}`,
                firstSlideMessage: window.translations.first_slide_message,
                lastSlideMessage: window.translations.last_slide_message,
                slideLabelMessage: `${window.translations.slide_label} {{index}} ${window.translations.slide_label_from} {{slidesLength}}`
            },
            navigation: {
                nextEl: this.$nextButton,
                prevEl: this.$prevButton
            },
            keyboard: true,
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    spaceBetween: 22
                },
                1280: {
                    slidesPerView: 3,
                    spaceBetween: 22
                }
            }
        });
    }
}

export { Offer };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $lotOffer = $context.querySelectorAll('[data-lot-offer="root"]');

    if ($lotOffer.length > 0) {
        const lotOffer = [];
        $lotOffer.forEach(($offer, index) => {
            lotOffer[index] = new Offer($offer);
            lotOffer[index].init();
        });
    }
});
